// 时间无限常量 3000年
export const TIME_INFINITE = 32503651200000;

export const DEFAULT_AVATOR =
  'https://edu-image.nosdn.127.net/49E89BEA3F1B3F1AC788F5F94C4A457F.png';
